import { render, staticRenderFns } from "./error-logout.vue?vue&type=template&id=a8d1f198&scoped=true&"
import script from "./error-logout.vue?vue&type=script&lang=ts&"
export * from "./error-logout.vue?vue&type=script&lang=ts&"
import style0 from "./error-logout.vue?vue&type=style&index=0&id=a8d1f198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d1f198",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VContainer,VLayout,VMain})
